import React, { Component, Fragment } from 'react'
import { v4 as uuidv4 } from 'uuid'
import * as R from 'ramda'
import i18n from 'i18next'
import Input from '../form/Input'
import Checkbox from '../form/Checkbox'
import './chartCreation.scss'
import PageQuestionChart from '../../Models/PageQuestionChart'
import ChartOptions from './ChartOptions'

class ChartCreation extends Component {
    chartTypes = {
        NF: [
            { value: 'peopleChart', label: 'People' },
            { value: 'pieChart', label: 'Spend Donut Chart' },
            { value: 'barLineChartVertical', label: 'Spend Columns chart with line chart' },
            { value: 'percentageBarChartHorizontal', label: 'Percentage bar chart' },
        ],
        RD: [{ value: 'starChart', label: 'Star rating' }],
        TB: [{ value: 'starChart', label: 'Star rating' }],
        PC: [{ value: 'percentageBarChartVertical', label: '% Column chart' }],
    }

    kpiOptions = {
        OAS: { label: 'Objective Success Score', charts: [{ value: 'guageChart', label: 'Guage Chart' }] },
        ST: { label: 'Strategy', charts: [{ value: 'guageChart', label: 'Guage Chart' }] },
        EV: { label: 'Event Value', charts: [{ value: 'radarChart', label: 'Radar Chart' }] },
        LS: { label: 'Lead Success', charts: [{ value: 'guageChart', label: 'Guage Chart' }] },
        OV: { label: 'Maxbi (Overall)', charts: [{ value: 'guageChart', label: 'Guage Chart' }] },
    }

    constructor(props) {
        super(props)
        this.state = {
            chartOptions: [],
            pages: [],
            chartPageTitle: '',
            errorCharts: [],
            className: '',
            showComingSoon: false,
        }
    }

    componentDidMount() {
        const { store, setSaveFunction } = this.props
        const { survey } = store
        const { pages } = survey
        const { defaultLocale } = survey.metadata

        setSaveFunction?.(this.saveCharts)

        const currentPage = pages.find((p) => p.id === store.chartCreationPageId)
        const allowedPages = pages.filter((p) => p.pageType === 'ST' && p.priority <= currentPage.priority)
        const chartPageTitle = R.pathOr({ [defaultLocale]: '' }, ['pageChart', 'title'], currentPage)
        const className = R.pathOr('', ['pageChart', 'className'], currentPage)
        const showComingSoon = R.pathOr(false, ['pageChart', 'showComingSoon'], currentPage)
        const currentCharts = []
        const errorCharts = []

        const { taxonomy } = store.survey.metadata
        const { surveyType } = taxonomy

        if (surveyType === 'EM') {
            this.kpiOptions = store.surveyKpis.reduce((options, { kpiId, name }) => (
                Object.assign(options, {
                    [kpiId]: {
                        label: name,
                        charts: kpiId === 'EV'
                            ? [
                                { value: 'radarChart', label: 'Radar Chart' },
                                { value: 'kpiDetails', label: 'KPI Details' },
                            ]
                            : [
                                { value: 'guageChart', label: 'Guage Chart' },
                                { value: 'rangedText', label: 'Ranged Text Chart' },
                                { value: 'rooChart', label: 'ROO chart' },
                            ],

                    },
                })
            ), {})
        }

        if (R.pathOr([], ['pageChart', 'pageQuestionChart'], currentPage).length) {
            const { pageQuestionChart } = currentPage.pageChart

            const questions = allowedPages.map((p) => p.questions.slice()).flat(2)

            let currentQuestion
            pageQuestionChart.forEach((chart) => {
                currentQuestion = questions.find((q) => q.questionId === chart.questionId)

                if (!currentQuestion && !chart.kpiType) {
                    errorCharts.push({
                        chart: new PageQuestionChart({
                            ...chart,
                        }),
                    })
                } else {
                    currentCharts.push({
                        chart: new PageQuestionChart({
                            ...chart,
                        }),
                        question: chart.kpiType ? undefined : currentQuestion,
                        questionOption: !chart.kpiType && currentQuestion.question.questionTypeCode === 'TB'
                            ? currentQuestion.question.optionSetY.options
                                .find((o) => o.id === chart.set1)
                            : undefined,
                    })
                }
            })
        }
        this.setState({
            chartOptions: currentCharts,
            pages: allowedPages,
            chartPageTitle,
            errorCharts,
            className,
            showComingSoon,
        })
    }

    chartPageTitleChange = (field) => {
        const { store } = this.props
        const { surveyLocale } = store
        const { chartPageTitle } = this.state
        this.setState({ chartPageTitle: { ...chartPageTitle, [surveyLocale]: field.value } })
    }

    changeShowComingSoon = () => {
        const { showComingSoon } = this.state
        this.setState({ showComingSoon: !showComingSoon })
    }

    changeClassName = ({ value }) => {
        this.setState({ className: value })
    }

    getChartPageTitle = () => {
        const { store } = this.props
        const { survey, surveyLocale } = store
        const { defaultLocale } = survey.metadata
        const { chartPageTitle } = this.state
        return R.hasPath([surveyLocale], chartPageTitle)
            ? chartPageTitle[surveyLocale]
            : chartPageTitle[defaultLocale]
    }

    addChartOptions = (question, questionOption, kpiType) => {
        const { store } = this.props
        const { survey } = store
        const { defaultLocale } = survey.metadata
        const { chartOptions } = this.state
        this.setState({
            chartOptions: [...chartOptions, {
                chart: new PageQuestionChart({
                    questionId: kpiType ? '00000000-0000-0000-0000-000000000000' : question.questionId,
                    chartId: uuidv4(),
                    title: { [defaultLocale]: '' },
                    set1: R.pathOr(undefined, ['id'], questionOption),
                    chartType: this.getChartTypes(question, kpiType)[0].value,
                    kpiType,
                }),
                question,
                questionOption,
            }],
        })
    }

    removeChartOptions = (chartId) => {
        const { chartOptions } = this.state
        this.setState({ chartOptions: chartOptions.filter((option) => option.chart.chartId !== chartId) })
    }

    removeErrorChartOptions = (chartId) => {
        const { errorCharts } = this.state
        this.setState({ errorCharts: errorCharts.filter((option) => option.chart.chartId !== chartId) })
    }

    getQuestionTitle = (question, kpiType) => {
        if (kpiType) return this.kpiOptions[kpiType].label
        const { store } = this.props
        const { survey, surveyLocale } = store
        const { defaultLocale } = survey.metadata

        return question.question.content.getTitleByLocale('shortTitle', surveyLocale, defaultLocale)
    }

    getMatrixQuestionTitle = (option, question) => {
        const { store } = this.props
        const { survey, surveyLocale } = store
        const { defaultLocale } = survey.metadata

        return option.getTitle(
            surveyLocale,
            defaultLocale,
            question.question.metadata.initialLocale,
        )
    }

    renderQuestions = (questions) => {
        const questionElement = (question, option) => (
            <div className="question" onClick={() => this.addChartOptions(question, option)}>
                <i className="fal fa-plus" />
                {option
                    ? `${this.getQuestionTitle(question)} - ${this.getMatrixQuestionTitle(option, question)}`
                    : this.getQuestionTitle(question)}
            </div>
        )

        return (
            <Fragment>
                {questions.map((question) => {
                    if (question.isHidden) return null

                    switch (question.question.questionTypeCode) {
                        case ('NF'):
                            return questionElement(question)
                        case ('RD'):
                            return R.pathOr(false, ['question', 'optionSet', 'hasNumericCodes'], question)
                                ? questionElement(question)
                                : null
                        case ('PC'):
                            return questionElement(question)
                        case ('TB'):
                            return R.pathOr(false, ['question', 'optionSetX', 'hasNumericCodes'], question)
                                ? question.question.optionSetY.options
                                    .map((option) => questionElement(question, option))
                                : null
                        default:
                            return null
                    }
                })}
            </Fragment>
        )
    }

    renderKpiOptions = () => {
        const kpiElement = (kpiType) => (
            <div className="question" onClick={() => this.addChartOptions(undefined, undefined, kpiType)}>
                <i className="fal fa-plus" />
                {this.kpiOptions[kpiType].label}
            </div>
        )

        return (
            <Fragment>
                {
                    Object.keys(this.kpiOptions)
                        .map((kpiType) => (
                            kpiElement(kpiType)
                        ))
                }
            </Fragment>
        )
    }

    pageOptions = () => {
        const { pages } = this.state
        return (
            <Fragment>
                {pages.map((page) => (
                    <div className="pages">
                        <span>{page.title}</span>
                        <div className="questions">
                            {this.renderQuestions(page.questions)}
                        </div>
                    </div>
                ))}
            </Fragment>
        )
    }

    discardChartChanges = () => {
        const { store } = this.props
        store.showChartCreation = false
        store.chartCreationPageId = null
    }

    getChartTitle = (title) => {
        const { store } = this.props
        const { survey, surveyLocale } = store
        const { defaultLocale } = survey.metadata
        return R.hasPath([surveyLocale], title)
            ? title[surveyLocale]
            : title[defaultLocale]
    }

    saveCharts = async () => {
        const { store } = this.props
        const { survey } = store
        const { pages } = survey
        const {
            chartOptions, chartPageTitle, className, showComingSoon,
        } = this.state

        const currentPage = pages.find((p) => p.id === store.chartCreationPageId)

        const formulaTests = chartOptions.map(({ chart }) => chart.testFormula())
        const invalidFormulas = formulaTests.filter((t) => !t.success)
        if (invalidFormulas.length) {
            store.handleError({
                body: `Error saving charts- formula error - chart: ${this.getChartTitle(invalidFormulas[0].title)}`,
                level: 'error',
            })
            return
        }

        const chartData = chartOptions.map(({ chart }) => (chart.toJSON()))

        const pageChartData = {
            title: chartPageTitle,
            pageQuestionChart: chartData,
            className,
            showComingSoon,
        }

        const pageData = {
            isRandomized: currentPage.isRandomized,
            title: currentPage.title,
            isHidden: currentPage.isHidden,
            pageChart: pageChartData,
            template: currentPage.template,
        }

        try {
            await store.http.put(`/api/survey/${survey.id}/page/${store.chartCreationPageId}`, JSON.stringify(pageData), store.surveyToken)
            const changedPageindex = survey.pages
                .findIndex((p) => p.id === store.chartCreationPageId)
            survey.pages[changedPageindex].pageChart = pageChartData
            store.addNotification({ body: 'Charts Updated', level: 'success' })
            store.showChartCreation = false
            store.chartCreationPageId = null
        } catch (e) {
            store.handleError({ body: 'Error saving charts', level: 'error' })
        }
    }

    getChartTypes = (question, kpiType) => {
        if (question) return this.chartTypes[question.question.questionTypeCode]
        return this.kpiOptions[kpiType].charts
    }

    render() {
        const { store } = this.props
        const {
            chartOptions,
            errorCharts,
            pages,
            className,
            showComingSoon,
        } = this.state
        return (
            <div className="ChartCreation">
                <div className="row">
                    <div className="left">
                        <h4>{i18n.t('chartCreation.aspects')}</h4>
                        <span>{i18n.t('chartCreation.prevAndCur')}</span>
                        <div className="pages">
                            <span>{i18n.t('chartCreation.KPIOptions')}</span>
                            <div className="questions">
                                {this.renderKpiOptions()}
                            </div>
                        </div>
                        {this.pageOptions()}
                    </div>
                    <div className="right" style={{ paddingTop: '41px' }}>
                        <span>
                            {i18n.t('chartCreation.requireResponses')}
                        </span>
                        {chartOptions.length
                            ? (
                                <Fragment>
                                    <div className="chartPageTitle">
                                        <span>{i18n.t('chartCreation.pageTitle')}</span>
                                        <Input
                                            name="chartPageTitle"
                                            defaultValue={this.getChartPageTitle()}
                                            onBlur={this.chartPageTitleChange}
                                        />
                                    </div>
                                    <div style={{ display: 'flex', marginTop: '8px' }}>
                                        <span>{i18n.t('chartCreation.showComingSoon', 'Show coming soon text')}</span>
                                        <Checkbox
                                            defaultChecked={showComingSoon}
                                            onBlur={this.changeShowComingSoon}
                                            style={{ marginLeft: '10px' }}
                                        />
                                    </div>
                                    <div style={{
                                        display: 'flex', marginTop: '8px', alignItems: 'center', gap: '10px',
                                    }}
                                    >
                                        <span>{i18n.t('chartCreation.className', 'Custom class names')}</span>
                                        <Input
                                            defaultValue={className}
                                            onBlur={this.changeClassName}
                                            style={{ marginLeft: '10px' }}
                                        />
                                    </div>
                                </Fragment>
                            ) : null}
                        <div className="chartOptions">
                            {errorCharts.length
                                ? errorCharts.map(({ chart }) => (
                                    <ChartOptions
                                        chart={chart}
                                        removeChart={this.removeErrorChartOptions}
                                        chartTypes={[{ value: 'NA', label: 'NOT AVAILABLE' }]}
                                        questionTitle="Question Not Available"
                                        store={store}
                                        errorChart
                                        key={chart.chartId}
                                    />
                                ))
                                : null}
                            {chartOptions.length
                                ? chartOptions.map(({ chart, question, questionOption }) => (
                                    <ChartOptions
                                        chart={chart}
                                        removeChart={this.removeChartOptions}
                                        chartTypes={this.getChartTypes(question, chart.kpiType)}
                                        questionTitle={this.getQuestionTitle(question, chart.kpiType)}
                                        getOptionTitle={this.getMatrixQuestionTitle}
                                        getQuestionTitle={this.getQuestionTitle}
                                        store={store}
                                        question={question}
                                        questionOption={questionOption}
                                        pages={pages}
                                        key={chart.chartId}
                                    />
                                ))
                                : null}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ChartCreation
